import { IconButton, Tab, Tabs } from 'material-ui';
import SaveIcon from 'material-ui/svg-icons/content/save';
import BackIcon from 'material-ui/svg-icons/navigation/arrow-back';
import * as React from 'react';
import './../Styles/MultilanguageAddEditTopBarViewStyle.css';

interface IMultilanguageTopBarViewProps {
    onBack: any
    onLanguageChange: (v: string) => void
    languageTabValue: string
    onSave: () => void
    className?: string
}

export default class extends React.Component<IMultilanguageTopBarViewProps> {
    public render(): JSX.Element {
        const { className, onBack, languageTabValue, onLanguageChange, onSave } = this.props
        return (
            <div className={className}>
                <div className="side left">
                    {onBack ?
                        <IconButton
                            onClick={onBack}
                        >
                            <BackIcon />
                        </IconButton>
                        : null}
                </div>
                <div className="side center">
                    <Tabs
                        className="language-tab"
                        inkBarStyle={{ background: 'black' }}
                        value={languageTabValue}
                        // tslint:disable-next-line:jsx-no-lambda
                        onChange={(v) => onLanguageChange(v)}
                    >
                        <Tab
                            disableTouchRipple={true}
                            disableKeyboardFocus={true}
                            className="tab"
                            label="Русский"
                            value="ru"
                        />
                        <Tab
                            disableTouchRipple={true}
                            disableKeyboardFocus={true}
                            className="tab"
                            label="Английский"
                            value="en"
                        />
                    </Tabs>
                </div>
                <div className="side right">
                    <IconButton>
                        <SaveIcon onClick={() => onSave()} />
                    </IconButton>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/abstract/Views/MultilanguageAddEditTopBarView.tsx